// eslint-disable-next-line import/prefer-default-export
export const muiCardComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
  },
};
